import React from "react"
import Section from "../blocks/section"

export type VideoCard = {
  video_card_title: string
  video_card_subtitle: string
  video_url: string
}

function MVideoCards({ data }: { data: { headline: string, video_cards: VideoCard[] } & Record<string, any> }) {
  const {headline, video_cards} = data
  return (
    <Section baseClass="m-VideoCards" data={data} defaultPadding="small">
      <div className="m-VideoCards-wrapper">
        <div className="m-VideoCards-container">

          <h2 className="dfb-Headline dfb-Headline--h2 m-VideoCards-headline">
            {headline}
          </h2>

          <div className="m-VideoCards-grid">

            {video_cards.map((video_card: VideoCard) => (
              <div className="m-VideoCards-item">
                <a href="#" className="m-VideoCards-link" data-video-url={video_card.video_url}>
                  <button className="m-VideoCards-play" aria-label={`Play ${video_card.video_card_subtitle}`}>
                    <svg className="m-VideoCards-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="11" className="m-VideoCards-circle" />
                      <polygon points="10,8 16,12 10,16" className="m-VideoCards-arrow" />
                    </svg>
                  </button>
                  <div className="m-VideoCards-titles">
                    <div>{video_card.video_card_title}</div>
                    <div className="m-VideoCards-titles-title">{video_card.video_card_subtitle}</div>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="m-VideoCards-overlay">
        <div className="m-VideoCards-overlay-content">
          <iframe className="m-VideoCards-iframe" marginHeight="0" marginWidth="0" allowTransparency="true" overflow="hidden"
                  frameBorder="0"
                  scrolling="no" allowFullScreen="true"></iframe>
          <button className="m-VideoCards-close">&times;</button>
        </div>
      </div>
    </Section>
  )
}

export default MVideoCards